import React from 'react';
import { useTranslation } from 'react-i18next';

import { MunicipalityImage } from '../../../components/MunicipalityImage';
import Images from '../../../assets/images';
import { useSelector } from 'react-redux';
import { isAuthorizedSelector } from '../../../features/authenticationSlice';
import { CURRENT_HEARINGS_URL } from '../../../constants/urls';
import { Redirect } from 'react-router-dom';

const StartMain = () => {
  const isLoggedIn = useSelector(isAuthorizedSelector);
  const { t: translator } = useTranslation();

  if (isLoggedIn) {
    return <Redirect to={CURRENT_HEARINGS_URL} />;
  }

  return (
    <div id="startPageMainContent">
      <h2>{translator('general.welcomeHeader')}</h2>
      <h3>{translator('general.welcomeSubheading')}</h3>
      <MunicipalityImage
        alt={translator('general.municipalityLogoAltText')}
        imageUrl={Images.mainLogo}
      />
    </div>
  );
};

export { StartMain };
